import React, { Component } from 'react';
//import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
    WithStyles,
    createStyles,
    Button,
    Grid,
    Typography,
    Modal,
    Theme,
    Card,
    CardHeader,
    IconButton,
    CardContent,
    LinearProgress,
} from '@material-ui/core';
//import { MyPATCollapse } from '../../common';
import PublishSharpIcon from '@material-ui/icons/PublishSharp';
import { connect } from 'react-redux';
import { showVideoModal } from '../mylibrary/actions/showVideoProgressActions';
//import { showVideoModal } from './../../../actions/showVideoProgressActions';
import axios from '../../services/axios';
//import CustomInfoIcon from '../../common/CustomInfoIcon';

const styles = (theme: Theme) => createStyles({
  dashedBorder: {
      border: 'dashed 1px #000',
      padding: 8,
      borderRadius: 4
  },

  dashedBlock: {
      width: 600,
      margin: 20,
      height: 240
  },

  fontSize2X: {
      fontSize: 15
  },
  lineHeight2X: {
      lineHeight: 20
  },

  typographyStyle: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '15px',
      lineHeight: '20px',
      width: '100%'
  },

  
  modal: {
      display: 'flex',
      padding: 12,
      alignItems: 'center',
      justifyContent: 'center',
  },

  modalHeader: {
      height: 60,
      borderBottom: 'solid 1px #0004'
  },

  subHeadingFont: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 'bold'
  },

  margin1X: {
      margin: '6px'
  },
 buttonRoundBorder:{
    borderRadius : 0
 },
  cardContent: {
      overflow: 'hidden'
  },
  dragDropVideoText:{
    color:'#333333',
    fontSize:'16px',
    fontWeight: 'normal', 
    lineHeight:'20.8px',
    display:'block',
    paddingBottom:'20px',
  },
  dragDropContainer : {
    textAlign:'center',
    display:'block',
  },
  supportedTypeText : {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    color: '#666666',
    marginTop: '5px',
    display:'block',
    width: '100%',
  }
});


interface MathPixDataInterface {
  confidence: number,
  confidenceRate: number,
  text: string,
  html: string
}


//@ts-ignore
interface MyPATFileUploadProps extends WithStyles<typeof styles> {
    classes: any,
    showVideoModal: Function ,
    handleVideoSelect: Function,
    videoUploadHandler: Function,
    acceptedFileType?: [],
    displaySupportedMsg?: boolean,
}
interface MyPATFileUploadState {
  isUpload: boolean,
  zoomIcon: boolean,
  mathPixData: null | MathPixDataInterface,
  image: any,
  showZoomIcon: boolean
}



class MyPATFileUpload extends Component<MyPATFileUploadProps, MyPATFileUploadState>{
  upload: any = null
    textarea: any = null
    inputForPaste: any = null
    wrapperRef: any = null

    constructor(props: MyPATFileUploadProps, state: MyPATFileUploadState) {
        super(props);
        this.state = {
            isUpload: false,
            zoomIcon: false,
            mathPixData: null,
            image: null,
            showZoomIcon: false
        }
    }

   render() {
      const { classes } = this.props;
      const { isUpload } = this.state;
      const supportedTypes = this.props.acceptedFileType ? this.props.acceptedFileType.join(', ') : '';
      let supportedTypesMsg = 'Only ';
      if (this.props.acceptedFileType && this.props.displaySupportedMsg) {

          for (let i = 0; i < this.props.acceptedFileType.length; i++) {
            if (i === this.props.acceptedFileType.length - 1) {
                supportedTypesMsg = supportedTypesMsg + ((i === 0) ? '' : ' and ') + this.props.acceptedFileType[i] +  ((i === 0) ? ' is' : ' are');
            } else {
                supportedTypesMsg = supportedTypesMsg + this.props.acceptedFileType[i] + (i === this.props.acceptedFileType.length - 2 ? '' : ', ');
            }
          }
          supportedTypesMsg += ' supported';
      }

        return (
        
             <div>
                <div ref={(ref) => { this.wrapperRef = ref; }} className={classes.dragDropContainer}>
                   
                    <Grid container justify="center"
                        onDragOver={(event) => { event.preventDefault(); }}
                        onDrop={
                            (event) => {
                                event.preventDefault();
                                this.props.handleVideoSelect(event)
                            }
                        }
                       // style={!isUpload && document && document.activeElement && document.activeElement.id === 'inputForPaste' ? { opacity: 0.5 } : {}}
                    >
                        <div>
                        <Typography className={classes.dragDropVideoText} component="div" variant="body1" align="center">
                                 Drag and Drop or Select file from your system
                            </Typography>
                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.mb1x}
                                    onClick={(e) => { this.upload.value = ''; this.upload.click() }}
                                    ><img src="/assets/svg/learn/fileAttach.svg" />&nbsp;Choose file
                                    </Button>
                                {/* <img alt="Video Upload" src="/assets/svg/learn/videoUploadIcon.svg" onClick={(e) => { this.upload.value = ''; this.upload.click() }} style={{ cursor: 'pointer', }} /> */}
                            </div>
                            
                        </div>
                        <input accept={supportedTypes} id="myInput" onChange={(event) => {
                            this.props.handleVideoSelect(event)
                        }} type="file" ref={(ref) => this.upload = ref} style={{ display: 'none' }} />
                        <input accept={supportedTypes} id="inputForPaste" type="text" ref={(ref) => this.inputForPaste = ref} onPaste={(event) => { this.props.handleVideoSelect(event) }} style={{ opacity: 0, width: 0 }} />
                        {this.props.displaySupportedMsg &&
                            <Typography className={classes.supportedTypeText} component="div" variant="body1" align="center">
                                {supportedTypesMsg}
                            </Typography>
                        }
                    </Grid>
                </div>

            </div>
      

        )
    }
}

function mapStateToProps(state: any) {
    return {
        openModal: state.showVideoModalReducers.openModal,
    }
}

const mapDispatchToProps = {
    showVideoModal
};

// @ts-ignore
export default connect(mapStateToProps,mapDispatchToProps) (withStyles(styles)(MyPATFileUpload));